var _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPodcast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3155",
    "data-name": "Group 3155",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.52,
    height: 21.421,
    viewBox: "0 0 18.52 21.421",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_976",
    width: 3.969,
    height: 21.421,
    rx: 1.984,
    transform: "translate(14.551)",
    fill: "#3e3e3e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1020",
    "data-name": "Rectangle 1020",
    width: 3.969,
    height: 16.588,
    rx: 1.984,
    transform: "translate(7.174 2.418)",
    fill: "#3e3e3e"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1021",
    "data-name": "Rectangle 1021",
    width: 3.969,
    height: 10.154,
    rx: 1.984,
    transform: "translate(0 5.807)",
    fill: "#3e3e3e"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodcast);
export default __webpack_public_path__ + "static/media/podcast.7c6c071616b8d5f75a92b707183103f7.svg";
export { ForwardRef as ReactComponent };